import { ColDef } from '@ag-grid-community/core';

export const GRID_PAGE_SIZE = 25;

export const COLUMN_PERSISTENCE_KEY = 'document-search-columns';

export const additionalDefaultColDef: ColDef<any> = {
  comparator: () => 0, // Prevent sort trigger before data loads when using client side data model
};

export const DEFAULT_SORT_ORDER: 'asc' | 'desc' = 'asc';
